
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects",
      function () {
        return require("private-next-pages/projects.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects"])
      });
    }
  